module.exports = __webpack_public_path__ + "img/platform-logo-tecan.853aff68.png";